import axios from 'axios'
import qs from 'qs'
const http = axios.create({
  paramsSerializer: params => {
    return qs.stringify(params, {
      arrayFormat: 'comma',
      skipNulls: true,
      allowDots: true
    })
  }
});
export default http
